// Static path
// @ts-ignore
export const staticFileLocation = STATIC_FILE_LOCATION;
